export default __webpack_public_path__ + "static/media/step1.d3b7e7c0.gif";